import { Grid } from '@material-ui/core';
import React from 'react';
import { Autocomplete } from 'mui-rff';
import { useTranslation } from 'react-i18next';
import QCXFinalForm from '../../shared-components/final-form/QCXFinalForm';
import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import { required as requiredValidator } from '../../utils/validators/field/validator';
import QCXFinalCheckboxField from '../../shared-components/final-checkbox-field/QCXFinalCheckboxField';
import TipoDocumentoUtils from '../../utils/general/tipo-documento/TipoDocumentoUtils';
import QCXFormSubtitle from '../form-title/QCXFormSubtitle';
import QCXRecintoAduaneiroBondManager from '../../shared-components/select-recinto-aduaneiro/QCXRecintoAduaneiroBondManager';

export const tipoDocumentoEnum = [
  {
    value: 'GUIA DE ICMS',
    id: 'GUIA_ICMS',
  },
  {
    value: 'EXONERACÃO ICMS',
    id: 'EXONERACAO',
  },
  {
    value: 'EXTRATO DA CONSULTA DO SISCARGA',
    id: 'EXTRATO_DA_CONSULTA_DO_SISCARGA',
  },
  {
    value: 'EXTRATO DA CONSULTA DO MARCANTE',
    id: 'EXTRATO_DA_CONSULTA_DO_MARCANTE',
  },
  {
    value: 'EXTRATO DA DECLARACAO DE IMPORTACAO',
    id: 'EXTRATO_DA_DECLARACAO_DE_IMPORTACAO',
  },
  {
    value: 'EXTRATO DA CI',
    id: 'EXTRATO_DA_CI',
  },
  {
    value: 'CONHECIMENTO DE TRANSPORTE',
    id: 'CONHECIMENTO_TRANSPORTE',
  },
  {
    value: 'AEREO',
    id: 'AEREO',
  },
  {
    value: 'EXTRATO CCT',
    id: 'EXTRATO_CCT',
  },
  {
    value: 'DANFE',
    id: 'DANFE',
  },
  {
    value: 'NUMERÁRIO',
    id: 'NUMERARIO',
  },
];

export default function QCXTipoDocumentoFinalForm({
  isCreate,
  isConsult,
  isUpdate,
  initialValues,
  handleSubmit,
  handleChangeToUpdate,
  handleCancelUpdate,
  authInfo = {},
  requiredRoles = [],
  disablePristine,
  ...restProps
}) {
  const { t } = useTranslation();

  return (
    <QCXFinalForm
      isConsult={isConsult}
      isUpdate={isUpdate}
      initialValues={initialValues}
      handleSubmitValues={handleSubmit}
      handleChangeToUpdate={handleChangeToUpdate}
      handleCancelUpdate={handleCancelUpdate}
      authInfo={authInfo}
      requiredRoles={requiredRoles}
      disablePristine={disablePristine}
      {...restProps}
    >
      {({ form, values }) => (
        <>
          {!isCreate && (
            <Grid item xs={12} sm={4} md={2}>
              <QCXFinalTextField
                id="final-text-field-id"
                key="text-field-id"
                label={t('com.muralis.qcx.codigo')}
                name="id"
                disabled
              />
            </Grid>
          )}
          <Grid item xs={12} sm={8} md={6}>
            <QCXFinalTextField
              id="text-field-description"
              key="text-field-description"
              label={t('com.muralis.qcx.documento.nomeDocumento')}
              name="description"
              validate={requiredValidator}
              disabled={isConsult}
              required
            />
          </Grid>

          <Grid item xs={12} sm={12} md={4}>
            <Autocomplete
              label={String(t('com.muralis.qcx.documento.tipoDocumento')).toUpperCase()}
              id="select-field-tipo-documento"
              name="tipoDocumento"
              options={tipoDocumentoEnum}
              getOptionLabel={(option) => option.value}
              defaultValue={undefined}
              disabled={isConsult}
              renderInput={(params) => (
                <QCXFinalTextField
                  {...params}
                  name="tipoDocumento"
                  label={String(t('com.muralis.qcx.documento.tipoDocumento')).toUpperCase()}
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </Grid>
          <Grid item md={6}>
            <QCXFinalTextField
              id="text-field-nomepadrao"
              key="text-field-nomepadrao"
              label={t('com.muralis.qcx.documento.nomePadrao')}
              name="nomePadrao"
              validate={requiredValidator}
              disabled={isConsult}
              required
            />
          </Grid>
          <Grid item md={6}>
            <QCXFinalTextField
              id="text-field-nomepadrao"
              key="text-field-nomepadrao"
              label="Exemplo Arquivo PDF:"
              name="ignorableFields.nomeExemplo"
              value={values?.nomePadrao ? `<numero_processo>_${values?.nomePadrao}.pdf` : ''}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={4} md={isCreate ? 6 : 4}>
            <QCXFinalCheckboxField
              id="text-field-publico"
              key="text-field-publico"
              label={t('com.muralis.qcx.publico')}
              name="publico"
              value={TipoDocumentoUtils.PUBLICO}
              disabled={isConsult}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={isCreate ? 6 : 4}>
            <QCXFinalCheckboxField
              id="text-field-cadastro-cliente"
              key="text-field-cadastro-cliente"
              label={t('com.muralis.qcx.cliente.cadastroCliente')}
              name="cadastroCliente"
              disabled={isConsult}
            />
          </Grid>

          <Grid item xs={12}>
            <QCXFormSubtitle title="Enviar como anexo no email de :" />
          </Grid>

          <Grid item xs={12} sm={4} md={isCreate ? 6 : 4}>
            <QCXFinalCheckboxField
              id="text-field-publico"
              key="text-field-publico"
              label={t('com.muralis.qcx.documento.tipoEnvioIcms')}
              name="envioEmailIcms"
              disabled={isConsult}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={isCreate ? 6 : 4}>
            <QCXFinalCheckboxField
              id="text-field-publico"
              key="text-field-publico"
              label={t('com.muralis.qcx.documento.tipoEnvioRegsitroDi')}
              name="envioEmailRegistroDi"
              disabled={isConsult}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={isCreate ? 6 : 4}>
            <QCXFinalCheckboxField
              id="text-field-publico"
              key="text-field-publico"
              label={t('com.muralis.qcx.documento.tipoEnvioDesembaraco')}
              name="envioEmailDesembaraco"
              disabled={isConsult}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={isCreate ? 6 : 4}>
            <QCXFinalCheckboxField
              id="text-field-publico"
              key="text-field-publico"
              label={t('com.muralis.qcx.documento.tipoEnvioTransporte')}
              name="envioEmailTransporte"
              disabled={isConsult}
            />
          </Grid>

          {
            values?.envioEmailTransporte === true ? (
              <>
                <Grid item xs={12}>
                  <QCXFormSubtitle title="Documento obrigatório nos recintos:" />
                </Grid>

                <Grid item xs={12}>
                  <QCXFinalCheckboxField
                    id="cbx-field-documento-obrigatorio-todos-recintos"
                    key="cbx-field-documento-obrigatorio-todos-recintos"
                    name="documentoObrigatorioTodosRecintos"
                    label="Obrigatório em todos os recintos"
                    disabled={isConsult}
                    onChange={(e) => {
                      if (e.target.checked) form.change('listaRecintoAduaneiroEnvioEmail', []);
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <QCXRecintoAduaneiroBondManager isConsult={isConsult || values?.documentoObrigatorioTodosRecintos} />
                </Grid>
              </>
            ) : null
          }
        </>
      )
      }
    </QCXFinalForm >
  );
}
